import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeTop20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconEdgeTop20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.95 13.45a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1-4.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1-2.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2-4.4a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zm11 3.4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3.5 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5-9a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-10.5 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeTop20);
